import React from "react";
import { useShallow } from "zustand/react/shallow";
import {
    Card,
    RoomPlayer
} from "@uno/protocol";
import useStoreRoomPlayer from "../../../store/useStoreRoomPlayer";
import useStoreRoomScene from "../../../store/useStoreRoomScene";
import useStoreAnimation from "../../../store/useStoreAnimation";
import FromRoomPlayerHandToDiscardAnimation from "../../../animation/FromRoomPlayerHandToDiscardAnimation";

const useRoomPlayerPuttingCard = () => {
    const [replaceCardFromRoomScene, atPosition] = useStoreRoomScene(useShallow(state => [state.replace, state.position]));
    const enqueueAnimation = useStoreAnimation(useShallow(state => state.enqueue));

    return React.useCallback(({ roomPlayer: originRoomPlayer, card, position }: { roomPlayer: RoomPlayer, card: Card, position: number }) => {
        const myPlayerId = useStoreRoomPlayer.getState().roomPlayer?.player?.id;

        if(myPlayerId === originRoomPlayer.player.id) {
            return;
        }

        const { initial, effects, transitions, duration, onAnimationEnd } = FromRoomPlayerHandToDiscardAnimation(originRoomPlayer.player.id, atPosition(originRoomPlayer.player.id, card.id), position);
        replaceCardFromRoomScene(originRoomPlayer.player.id, card.id, { id: card.id, type: card.type, canBePut: false, isHoverable: false });
        enqueueAnimation(card.id, { name: "room-player-putting-card", initial, effects, transitions, duration, onAnimationEnd });
    }, []);
}

export default useRoomPlayerPuttingCard;
